var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    style: "\n    height: ".concat(_vm.clientHeight - 68, "px;\n    ").concat(_vm.$vuetify.theme.dark ? 'background-color: rgb(66,66,66)' : 'background-color: rgb(250, 250, 250);', "\n    ")
  }, [_c('div', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-signature-freehand")]), _vm._v(" " + _vm._s(_vm.$t("sign.Sign.signedTitle")) + " ")], 1)], 1), _c('div', {
    staticClass: "mt-n6",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('v-spacer'), _c('v-card-subtitle', {
    staticClass: "justify-center align-center",
    domProps: {
      "innerHTML": _vm._s(_vm.signedSubtitle)
    }
  }), _c('v-spacer')], 1), _vm.signed.status !== 'signed' ? _c('div', {
    staticClass: "pt-4 mx-auto"
  }, [_c('v-card-subtitle', {
    staticClass: "ma-auto justify-center align-center",
    staticStyle: {
      "max-width": "500px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.signing'))
    }
  })], 1) : _vm._e(), _vm.signed.status === 'signed' ? _c('div', {
    staticStyle: {
      "height": "40px",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('div', {
    staticClass: "ma-auto"
  }, [_vm.pages.length > 1 ? _c('span', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.goPreviousPage
    }
  }, [_c('v-icon', [_vm._v(" mdi-chevron-left ")])], 1), _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.goNextPage
    }
  }, [_c('v-icon', [_vm._v(" mdi-chevron-right ")])], 1)], 1) : _vm._e(), _c('v-btn', {
    class: !_vm.$vuetify.breakpoint.smAndDown ? 'mr-4 ml-4' : 'ml-2 mr-2',
    attrs: {
      "elevation": 0,
      "loading": _vm.loadingDownload
    },
    on: {
      "click": _vm.download
    }
  }, [!_vm.$vuetify.breakpoint.smAndDown ? _c('div', [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.downloadDocument")) + " ")]) : _vm._e(), _c('v-icon', {
    staticClass: "ml-1"
  }, [_vm._v(" mdi-download-outline ")])], 1), _c('v-btn', {
    attrs: {
      "href": _vm.signed.documents[0],
      "target": "_blank",
      "elevation": 0
    }
  }, [_c('v-icon', [_vm._v(" mdi-open-in-new ")])], 1)], 1)]) : _vm._e(), _vm.signed.status !== 'signed' ? _c('div', [_c('v-row', {
    staticClass: "pt-12"
  }, [_c('v-progress-circular', {
    staticClass: "ma-auto justify-center align-center",
    attrs: {
      "rotate": 360,
      "size": 150,
      "indeterminate": "",
      "justify": "center"
    }
  }, [_c('span', {
    staticClass: "font-weight-medium "
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.SignFormSigned.value", {
    value: _vm.value
  })) + " ")])])], 1), _c('v-row', {
    staticClass: "pt-4"
  }, [_c('vue-typer', {
    staticClass: "font-weight-medium ma-auto justify-center align-center",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "text": _vm.workText
    }
  })], 1), _c('v-row', {
    staticClass: "pt-4"
  }, [_c('v-card-subtitle', {
    staticClass: "ma-auto justify-center align-center",
    staticStyle: {
      "max-width": "500px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.signingDescription'))
    }
  })], 1)], 1) : _c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('v-window', {
    staticClass: "ma-auto",
    style: "height: ".concat(_vm.clientHeight - 250, "px;"),
    attrs: {
      "horizontal": ""
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }, [_vm.loading ? _c('v-row', {
    staticClass: "fill-height ma-0",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._l(_vm.pages, function (page) {
    return _c('v-window-item', {
      key: page
    }, [_c('v-img', {
      style: "height: ".concat(_vm.clientHeight - 250, "px;"),
      attrs: {
        "src": page,
        "contain": ""
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function fn() {
          return [_c('v-row', {
            staticClass: "fill-height ma-0",
            attrs: {
              "align": "center",
              "justify": "center"
            }
          }, [_c('v-progress-circular', {
            attrs: {
              "indeterminate": ""
            }
          })], 1)];
        },
        proxy: true
      }], null, true)
    })], 1);
  })], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }